import type { Board } from '@atlassian/jira-navigation-types/src/types.tsx';
import type { RecentBoard } from '../../rest/recent-boards/get/index.tsx';
import { createBoardUrl } from '../common/index.tsx';

const USER_TYPE_BOARD = 'user';

export const transformRecentBoards = (recentBoards: RecentBoard[]): Board[] =>
	recentBoards.map(
		({
			id,
			name,
			isSimpleBoard,
			location: {
				displayText: locationName,
				avatarUrl: locationAvatarUrl,
				type,
				accountId,
				locationKey,
			},
		}) => ({
			id: String(id),
			name,
			url: createBoardUrl(id, locationKey, accountId, isSimpleBoard),
			isLocationUser: type === USER_TYPE_BOARD,
			locationName,
			locationAvatarUrl,
		}),
	);
